import { useTranslation } from 'react-i18next';

import { AnimatedModal } from 'components/AnimatedModal/AnimatedModal';
import { EmailTemplateForm } from 'components/EmailTemplateForm/EmailTemplateForm';

export const EmailTemplateModal = ({ visible, onClose, onSubmit, initialValues, isLoading }) => {
  const { t } = useTranslation();

  const title = initialValues?.id
    ? t('emailTemplates.modal.editTitle')
    : t('emailTemplates.modal.createTitle');

  return (
    <AnimatedModal visible={visible} onClose={onClose} title={title} fullscreen>
      {visible && (
        <EmailTemplateForm
          key={initialValues?.id ?? 'new'}
          initialValues={initialValues}
          onSubmit={onSubmit}
          onCancel={onClose}
          isLoading={isLoading}
        />
      )}
    </AnimatedModal>
  );
};
